import React from 'react';
import { Form, Input, Select, DatePicker, Upload, Button, Card, Divider } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const { Option } = Select;

const PreviewForm = ({ form }) => {
    const formValues = form.getFieldsValue();
    if (!formValues.campos) return null;

    const renderPreviewField = (field) => {
        if (!field || !field.tipo) return null;

        const placeholder = field.label ? `Ingrese ${field.label.toLowerCase()}` : 'Ingrese valor';

        switch (field.tipo) {
            case 'texto':
                return <Input placeholder={placeholder} />;
            case 'numero':
                return <Input type="number" placeholder={placeholder} />;
            case 'select':
                return (
                    <Select placeholder={placeholder}>
                        {field.opciones?.split(',').map((opt, index) => (
                            <Option key={index} value={opt.trim()}>
                                {opt.trim()}
                            </Option>
                        ))}
                    </Select>
                );
            case 'multiple_unico':
                return (
                    <Select
                        mode="single"
                        placeholder={placeholder}
                        style={{ width: '100%' }}
                    >
                        {field.opciones?.split(',').map((opt, index) => (
                            <Option key={index} value={opt.trim()}>
                                {opt.trim()}
                            </Option>
                        ))}
                    </Select>
                );
            case 'multiple_multiple':
                return (
                    <Select
                        mode="multiple"
                        placeholder={placeholder}
                        style={{ width: '100%' }}
                    >
                        {field.opciones?.split(',').map((opt, index) => (
                            <Option key={index} value={opt.trim()}>
                                {opt.trim()}
                            </Option>
                        ))}
                    </Select>
                );
            case 'fecha':
                return <DatePicker style={{ width: '100%' }} />;
            case 'imagen':
                return (
                    <Upload
                        listType="picture"
                        maxCount={1}
                        beforeUpload={() => false}
                    >
                        <Button icon={<UploadOutlined />}>Subir imagen</Button>
                    </Upload>
                );
            default:
                return <Input />;
        }
    };

    return (
        <Card title="Vista Previa del Formulario" style={{ marginTop: 16 }}>
            <h3>{formValues.nombre || 'Nombre del Formulario'}</h3>
            <p>{formValues.descripcion || 'Descripción del formulario'}</p>
            <Divider />
            <Form layout="vertical">
                {formValues.campos.map((field, index) => (
                    <Form.Item
                        key={index}
                        label={field.label || `Campo ${index + 1}`}
                        required={field.requerido}
                    >
                        {renderPreviewField(field)}
                    </Form.Item>
                ))}
            </Form>
        </Card>
    );
};

export default PreviewForm; 